export const filters_tmpl = {
    specialization: [
      { field: 'general', label: 'Загального розвитку', groups: 'Загального розвитку' },
      { field: 'combined', label: 'Комбінуючий', groups: "Спеціальна" },
      { field: 'sanatorium', label: 'Санаторний', groups: "Санаторна" },
      { field: 'special', label: 'Спеціальний', groups: "Спеціальна" }
    ],
    disease_type: [
      // Загальні захворювання для санаторного та комбінованого
      { field: 'tuberculosis', label: 'З латентною туберкульозною інфекцією та після вилікування від туберкульозу' },
      { field: 'respiratory', label: 'З хронічними неспецифічними захворюваннями органів дихання' },
      { field: 'cardiovascular', label: 'Із захворюваннями серцево-судинної системи' },
      { field: 'endocrine', label: 'Із захворюваннями ендокринної системи' },
      { field: 'digestive', label: 'З хворобами органів травлення' },
      { field: 'psychoneurological', label: 'З психоневрологічними захворюваннями' },
      
      // Спеціальні захворювання для спеціального та комбінованого
      { field: 'hearing', label: 'З порушеннями слуху (глухих, зі зниженим слухом)' },
      { field: 'vision', label: 'З порушеннями зору (сліпих, зі зниженим зором)' },
      { field: 'speech', label: 'З порушеннями мови' },
      { field: 'musculoskeletal', label: 'З порушеннями опорно-рухового апарату' },
      { field: 'intellectual', label: 'З розумовою відсталістю' },
      { field: 'developmental', label: 'Із затримкою психічного розвитку' }
    ]
  };

export const filter_tmpl_specialist = {
  specialization: [
      { field: 'general', label: 'Загального розвитку', groups: 'Загального розвитку' },
      { field: 'combined', label: 'Компенсуючий (спеціальний)', groups: "Спеціальна" },
      { field: 'sanatorium', label: 'Компенсуючий (санаторний)', groups: "Санаторна" },
      { field: 'special', label: 'Інклюзивний', groups: "Спеціальна" }
    ],
    disease_type: [
      // Загальні захворювання для Компенсуючий (санаторний)
      { field: 'tuberculosis', label: 'З латентною туберкульозною інфекцією та після вилікування від туберкульозу' },
      { field: 'respiratory', label: 'З хронічними неспецифічними захворюваннями органів дихання' },
      { field: 'cardiovascular', label: 'Із захворюваннями серцево-судинної системи' },
      { field: 'endocrine', label: 'Із захворюваннями ендокринної системи' },
      { field: 'digestive', label: 'З хворобами органів травлення' },
      { field: 'psychoneurological', label: 'З психоневрологічними захворюваннями' },
      
      // Спеціальні захворювання для Компенсуючий (спеціальний)
      { field: 'hearing', label: 'З порушеннями слуху (глухих, зі зниженим слухом)' },
      { field: 'vision', label: 'З порушеннями зору (сліпих, зі зниженим зором)' },
      { field: 'speech', label: 'З порушеннями мови' },
      { field: 'musculoskeletal', label: 'З порушеннями опорно-рухового апарату' },
      { field: 'intellectual', label: 'З розумовою відсталістю' },
      { field: 'developmental', label: 'Із затримкою психічного розвитку' }
    ]
}
